module.exports = __webpack_public_path__ + "media/images/regional-image13-37b68249664fbc826091ac3fd9aec8cd.jpg";